import { getUser } from '../utils/paths';
import aiNativeBehaviorEvaluator from './aiNativeBehaviorEvaluator';
const JSON_SCHEMA_TYPES = ['object', 'array', 'string', 'number', 'integer', 'boolean', 'null'];

/** True if value looks like a literal JSON Schema (do not pass through sourceEvaluator). */
function isLiteralSchema(value) {
  if (value == null || typeof value !== 'object' || Array.isArray(value)) {
    return false;
  }
  return value.$schema != null || typeof value.type === 'string' && JSON_SCHEMA_TYPES.includes(value.type) || value.properties != null;
}

/**
 * Web-native aiDocumentParseBehavior: calls AI agents/parse directly with
 * source.documentKeys, source.schema, source.prompt; customer from current user.
 * Same contract as server aiDocumentParseBehavior.
 */
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const documentKeys = sourceEvaluator ? await sourceEvaluator(source.documentKeys) : source.documentKeys;
  // Do not pass schema through sourceEvaluator: a literal JSON Schema has type: 'object'
  // (or 'string', etc.), which evaluateSource would treat as a behavior type and fail.
  const sourceSchema = source.schema;
  let schema;
  if (isLiteralSchema(sourceSchema)) {
    schema = sourceSchema;
  } else if (sourceEvaluator) {
    schema = await sourceEvaluator(sourceSchema);
  } else {
    schema = sourceSchema;
  }
  const prompt = sourceEvaluator ? await sourceEvaluator(source.prompt) : source.prompt;
  const _getUser = getUser(),
    customer = _getUser.customer;
  if (!customer) {
    throw new Error('Customer is required for document parse');
  }
  // Default missing or invalid schema to {} so the AI service receives a valid object
  // and we avoid throwing (which would leave evaluateSource result undefined and break callers).
  const validSchema = schema != null && typeof schema === 'object' && !Array.isArray(schema) ? schema : {};
  const response = await aiNativeBehaviorEvaluator.documentParse(customer, documentKeys, validSchema, prompt);
  return response;
};
export default {
  evaluate
};